"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reencodeIfNeeded = exports.decodeStoredHtml = void 0;
// section.html is stored either raw or percent-encoded depending on how it
// was last saved — there is no single guaranteed convention (the admin
// editor's source view round-trips through encodeURIComponent; other writers
// don't). decodeChanged records which case this string was, so a caller that
// mutates the decoded form can re-encode only when the input actually was
// encoded, preserving whatever convention that particular section is using.
const decodeStoredHtml = (stored) => {
    try {
        const candidate = decodeURIComponent(stored);
        return {
            decoded: candidate,
            decodeChanged: candidate !== stored,
        };
    }
    catch (_a) {
        // malformed encoding — the storefront keeps the raw string, so use it
        return { decoded: stored, decodeChanged: false };
    }
};
exports.decodeStoredHtml = decodeStoredHtml;
const reencodeIfNeeded = (stored, decoded, next, decodeChanged) => {
    if (next === decoded)
        return stored;
    return decodeChanged ? encodeURIComponent(next) : next;
};
exports.reencodeIfNeeded = reencodeIfNeeded;
